import SimpleMail from './SimpleMail';

export default SimpleMail;


// WEBPACK FOOTER //
// /src/components/mailThread/mail/simpleMail/index.js